interface SectionHeadingProps {
  children: React.ReactNode;
}

export function SectionHeading({ children }: SectionHeadingProps) {
  return <p className="text-xs font-semibold tracking-wider text-muted-foreground uppercase">{children}</p>;
}
